import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-password-validation',
  templateUrl: './password-validation.component.html',
  styleUrls: ['./password-validation.component.scss'],
})
export class PasswordValidationComponent implements OnInit {
  public readonly checkIcon = faCheckCircle;
  public readonly uncheckIcon = faTimesCircle;

  @Input() public control: FormControl;

  constructor() {}

  public ngOnInit() {}
}
